// BNB Address, WETH Address in ETH
const BNB_ADDRESS = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'

export { BNB_ADDRESS }
